

export const idPhotoGeneration = {
    toolName: 'ID Photo Generation',
    toolDescription: 'Transform your photo into standard ID photos with support for multiple sizes and background colors',
    
    uploadImage: 'Upload Photo',
    uploadImageDescription: 'Upload a clear portrait photo, supports JPG, PNG formats',
    clickOrDragUpload: 'Click or drag to upload photo',
    
    photoSize: 'Photo Size',
    photoSizeDescription: 'Select the ID photo size you need',
    
    backgroundColor: 'Background Color',
    backgroundColorDescription: 'Choose the background color for your ID photo',
    
    sizes: {
      oneInch: {
        name: '1-inch Photo',
        desc: '2.5cm × 3.5cm, commonly used for ID cards, student cards, etc.'
      },
      twoInch: {
        name: '2-inch Photo',
        desc: '3.5cm × 5.3cm, commonly used for passports, visas, etc.'
      },
      passport: 'Passport Photo',
      passportDesc: '3.5cm × 4.5cm, meets passport standard size',
      visa: 'Visa Photo',
      visaDesc: '5.1cm × 5.1cm, meets US visa standard'
    },
    
    backgroundColors: {
      title: 'Background Color Selection'
    },
    
    generateButton: 'Generate ID Photo',
    generating: 'Generating...',
    generationComplete: 'ID photo generation complete',
    downloadPhoto: 'Download ID Photo',
    
    tips: {
      title: 'Photography Tips',
      items: [
        'Please use a clear front-facing photo',
        'Ensure sufficient lighting, avoid shadows',
        'Maintain natural expression, look directly at camera',
        'Avoid wearing hats or accessories that cover the face'
      ]
    }
  };
